import React from 'react';
import moment from "moment-timezone";
import {
    Card,
    CardHeader,
    Typography
} from '@mui/material';
import Grid from '@mui/material/Grid';

import CapLevelChip from "../common/CapLevelChip";
import PropertyGridDisplayComponent from "../common/PropertyGridDisplayComponent";
import FlagDisplay from "../common/FlagDisplay";
import {DATE_FORMAT_IN_READABLE_FORMAT} from "../../config/DateTimeConstants";

export default function ContentDetailsCard({ contentDetails }) {

    const contentDetailCardStyle = {backgroundColor: '#f2f8ff', maxWidth: '35rem', overflow: 'auto'};
    const contentGridStyle = {p: 1, minWidth: '20rem'};

    return (
      <>
          <Card sx={contentDetailCardStyle}>
              <CardHeader title={<Typography variant='h5' fontWeight='bold'>{contentDetails.text}</Typography>}/>
              <Grid sx={contentGridStyle}>
                  <PropertyGridDisplayComponent label="Service Type" text={contentDetails.serviceType}/>
                  <PropertyGridDisplayComponent label="Description" text={contentDetails.description}/>
                  <PropertyGridDisplayComponent label="External Name" text={contentDetails.externalName}/>
                  <PropertyGridDisplayComponent label="Code" text={contentDetails.code}/>
                  <PropertyGridDisplayComponent label="Created" text={moment(contentDetails.created).format(DATE_FORMAT_IN_READABLE_FORMAT)}/>
                  <PropertyGridDisplayComponent label="Content Type" text={contentDetails.contentType}/>
                  <PropertyGridDisplayComponent label="Is Assessed" component={<FlagDisplay isChecked={contentDetails.isAssessed} />} />
                  <PropertyGridDisplayComponent label="Content" text={contentDetails.content}/>
                  <PropertyGridDisplayComponent label="CAP Level" component={<CapLevelChip capLevel={contentDetails.capLevel}/>}/>
              </Grid>
          </Card>
      </>
    );
}
